import { enableProdMode } from '@angular/core';
import {
  AllEnterpriseModule,
  LicenseManager,
  ModuleRegistry,
  ValidationModule,
} from 'ag-grid-enterprise';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowser } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

ModuleRegistry.registerModules([
  AllEnterpriseModule,
  ...(environment.production ? [] : [ValidationModule]),
]);
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-116509}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Devinco_AS}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{3}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{12_January_2027}____[v3]_[01]_MTc5OTcxMjAwMDAwMA==be842e6a2637df67e54377f15ad867ad'
);

platformBrowser()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
